import {
  UpdateAIPersonasBody,
  updateAIPersonasResponseSchema,
  getKnowledgeSettingsResponseSchema,
  UpdateKnowledgeSettingsRequest,
  updateBriefGuidelinesResponseSchema,
  UpdateAskPunttSkillBody,
  updateAskPunttSkillResponseSchema,
  UpdateAskPunttEnabledBody,
  updateAskPunttEnabledResponseSchema,
  UpdateAskPunttConnectorBody,
  updateAskPunttConnectorResponseSchema,
  CreateCustomWorkflowBody,
  createCustomWorkflowResponseSchema,
  UpdateCustomWorkflowBody,
  updateCustomWorkflowResponseSchema,
  DeleteCustomWorkflowBody,
  deleteCustomWorkflowResponseSchema,
} from "@mg/schemas/src/christo/catalyst";

import { API_URL } from "../config/env";
import { smartFetch } from "../utils/http";
import { parseResponse } from "../utils/parseResponse";

export async function getGuidelines() {
  const json = await smartFetch(
    `${API_URL}/private/catalyst/knowledge-settings`,
    {
      method: "GET",
    },
  );

  const parsedData = parseResponse(getKnowledgeSettingsResponseSchema, json);

  return parsedData;
}

export async function updateGuidelines(
  payload: UpdateKnowledgeSettingsRequest["body"],
) {
  const json = await smartFetch(
    `${API_URL}/private/catalyst/knowledge-settings`,
    {
      method: "PUT",
      body: JSON.stringify({ ...payload }),
    },
  );

  const parsedData = updateBriefGuidelinesResponseSchema.parse(json);

  return parsedData;
}

export async function updateAIPersona(payload: UpdateAIPersonasBody) {
  const json = await smartFetch(`${API_URL}/private/catalyst/ai-personas`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

  const parsedData = updateAIPersonasResponseSchema.parse(json);
  return parsedData;
}

export async function updateAskPunttSkill(payload: UpdateAskPunttSkillBody) {
  const json = await smartFetch(`${API_URL}/private/catalyst/askpuntt-skills`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

  const parsedData = updateAskPunttSkillResponseSchema.parse(json);
  return parsedData;
}

export async function updateAskPunttEnabled(
  payload: UpdateAskPunttEnabledBody,
) {
  const json = await smartFetch(
    `${API_URL}/private/catalyst/askpuntt-enabled`,
    {
      method: "PUT",
      body: JSON.stringify(payload),
    },
  );

  const parsedData = updateAskPunttEnabledResponseSchema.parse(json);
  return parsedData;
}

export async function updateAskPunttConnector(
  payload: UpdateAskPunttConnectorBody,
) {
  const json = await smartFetch(
    `${API_URL}/private/catalyst/askpuntt-connectors`,
    {
      method: "PUT",
      body: JSON.stringify(payload),
    },
  );

  const parsedData = updateAskPunttConnectorResponseSchema.parse(json);
  return parsedData;
}

export async function createCustomWorkflow(payload: CreateCustomWorkflowBody) {
  const json = await smartFetch(
    `${API_URL}/private/catalyst/custom-workflows`,
    {
      method: "POST",
      body: JSON.stringify(payload),
    },
  );

  const parsedData = createCustomWorkflowResponseSchema.parse(json);
  return parsedData;
}

export async function updateCustomWorkflow(payload: UpdateCustomWorkflowBody) {
  const json = await smartFetch(
    `${API_URL}/private/catalyst/custom-workflows`,
    {
      method: "PUT",
      body: JSON.stringify(payload),
    },
  );

  const parsedData = updateCustomWorkflowResponseSchema.parse(json);
  return parsedData;
}

export async function deleteCustomWorkflow(payload: DeleteCustomWorkflowBody) {
  const json = await smartFetch(
    `${API_URL}/private/catalyst/custom-workflows`,
    {
      method: "DELETE",
      body: JSON.stringify(payload),
    },
  );

  const parsedData = deleteCustomWorkflowResponseSchema.parse(json);
  return parsedData;
}
